<script setup lang="ts">
import { InstagramIcon } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <Icon :path="InstagramIcon" :size="24" class="w-8" filled />
</template>
